import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticStyle:{"background-color":"#001E4A"}},[_c(VContainer,{staticClass:"mt-12 mb-12"},[_c(VRow,{staticClass:"ma-1"},[_c(VImg,{staticStyle:{"margin-left":"auto","margin-right":"auto"},attrs:{"max-height":_vm.$vuetify.breakpoint.lgAndUp ? 'calc(100vh - 0px)' : '1000',"src":_vm.Products,"alt":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }